import { instance } from "@/api/index";

export const empData = () => instance.get("/back/emp"); //사원 조회
export const empSet = payload => instance.post("/back/emp", payload); //사원 등록
export const empDetail = empNo => instance.get(`/back/emp/${empNo}`); //사원 상세
export const empList = () => instance.get("/back/common?params=rank,dept"); // 부서조회,사원조회
export const empEdit = (empNo, payload) =>
  instance.put(`/back/emp/${empNo}`, payload); // 사원 수정

export const listEmpVacation = () => instance.get("/back/empLeave/leave"); // 휴가관리 조회
export const addEmpVacation = (day, empList, note) =>
  instance.post(
    `/back/empLeave/grant?day=${day}&empList=${empList}&note=${note}`,
  ); // 휴가관리 조회
export const confirmVacation = (empNo, planNo) =>
  instance.post(`/back/empLeave/decide?empNo=${empNo}&planNo=${planNo}`); // 휴가 확정
export const regVacation = payload =>
  instance.post("/back/empLeave/reg", payload); // 휴가 등록
